import { Grid, Typography } from "@material-ui/core";
import React from "react";
import HtmlContent from "../shared/HtmlContent";
import { Statement } from "../../firebase/statements";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import { useTranslation } from "react-i18next";
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

interface Props {
  statement: Statement;
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "30px",
  },
  title: {
    color: colors.TEXT_PRIMARY,
    fontSize: "32px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.08px",
  },
  subtitle: {
    color: colors.TEXT_PRIMARY,
    fontSize: "20px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.05px",
  },
  text: {
    color: colors.TEXT_PRIMARY,
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.67",
    letterSpacing: "-0.05px;",
    margin: "0",
    padding: "0",
  },
  categoryContainer: {
    marginBottom: "30px",
    marginTop: "15px"
  },
  category: {
    color: colors.TEXT_SECONDARY,
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.03px",
  },
  link: {
    color: colors.LINK,
    fontSize: "16px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2",
    letterSpacing: "-0.04px",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default function About({ statement }: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const moreInfo =
    statement &&
    (statement.description || statement.category || statement.links.length > 0);

  return (
    <>
      <Grid container item xs={12} className={classes.container}>
        <Grid container item xs={1} sm={3} />
        <Grid container item sm={6} xs={10}>
          {moreInfo && (
            <Grid item xs={12}>
              <Typography component="h2" className={classes.title}>
                {t("statement.about")}
              </Typography>
            </Grid>
          )}

          {statement.description && (
            <Grid item xs={12}>
              <Typography className={classes.text}>
                <HtmlContent html={statement.description} />
              </Typography>
            </Grid>
          )}

          {statement.category && (
            <Grid item xs={12} className={classes.categoryContainer}>
              <Typography component="p" className={classes.category}>
                {t("statement.category")}: {statement.category}
              </Typography>
            </Grid>
          )}

          {statement.links.length > 0 && (
            <Grid item xs={12}>
              <Typography component="h3" className={classes.subtitle}>
                {t("statement.furtherreading")}
              </Typography>
              <ul>
                {statement.links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.value}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.link}
                    >
                      {link.name}
                      &nbsp;
                      <OpenInNewIcon style={{ fontSize: 16 }} />
                    </a>
                  </li>
                ))}
              </ul>
            </Grid>
          )}
        </Grid>
        <Grid container item xs={1} sm={3} />
      </Grid>
    </>
  );
}
